import React from 'react';
import './style.scss';

export const CartLoader: React.FC = () => (
  <li className="flex items-center space-x-4 p-6">
    {/* Image placeholder */}
    <div className="relative">
      <div className="w-20 h-20 bg-gray-200 rounded-md skeleton-shimmer" />
      {/* Quantity badge placeholder */}
      <div className="absolute top-0 right-0 min-w-5 min-h-5 px-1 py-0.5 rounded-full bg-gray-300 text-transparent"></div>
    </div>

    {/* Product info */}
    <div className="flex-auto space-y-2">
      <div className="h-4 w-32 bg-gray-200 rounded skeleton-shimmer"></div>
      <div className="h-3 w-24 bg-gray-200 rounded skeleton-shimmer"></div>

      {/* Quantity buttons placeholder */}
      <div className="flex gap-2 mt-4">
        <div className="w-8 h-8 bg-gray-200 rounded skeleton-shimmer"></div>
        <div className="w-8 h-8 bg-gray-200 rounded skeleton-shimmer"></div>
      </div>
    </div>

    {/* Price + remove button */}
    <div className="flex flex-col items-end gap-2">
      <div className="h-4 w-16 bg-gray-200 rounded skeleton-shimmer"></div>
      <div className="w-6 h-6 bg-gray-200 rounded-full skeleton-shimmer"></div>
    </div>
  </li>
);
